module.exports = __webpack_public_path__ + "assets/img/ds3.eba1f966.jpg";